import React from "react";
import logo from "../../../images/logo_white1.png";
import "./login.css";
import "./host.css";

const HostRegister = () => {
  return (
    <div className="host-login-bg d-flex flex-column min-vh-100 justify-content-center align-items-center position-relative">
      <div
        className="d-flex flex-column align-items-center"
        style={{ maxWidth: 540, width: "100%" }}
      >
        <div className="text-center w-100">
          <img
            src={logo}
            alt="somadome logo"
            className="mb-3"
            style={{ maxWidth: 420, width: "50vw", minWidth: 100 }}
          />
        </div>
        <form className="w-75 d-flex flex-column align-items-center mt-4">
          <div className="mb-1 w-100">
            <label
              className="lato-medium-20 text-white mb-2 text-center w-100"
              htmlFor="email"
            >
              Email
            </label>
            <input
              type="email"
              className="form-control bg-white bg-opacity-75 border-0 rounded-1 py-4-5 px-4 lato-medium-16 w-100"
              id="email"
              placeholder="Email"
            />
          </div>
          <div className="mb-1 w-100">
            <label
              className="lato-medium-20 text-white mb-2 text-center w-100"
              htmlFor="username"
            >
              User Name
            </label>
            <input
              type="text"
              className="form-control bg-white bg-opacity-75 border-0 rounded-1 py-4-5 px-4 lato-medium-16 w-100"
              id="username"
              placeholder="User Name"
            />
          </div>
          <div className="mb-1 w-100">
            <label
              className="lato-medium-20 text-white mb-2 text-center w-100"
              htmlFor="password"
            >
              Password
            </label>
            <input
              type="password"
              className="form-control bg-white bg-opacity-75 border-0 rounded-1 py-4-5 px-4 lato-medium-16 w-100"
              id="password"
              placeholder="Password"
            />
          </div>
          <div className="mb-4 w-100">
            <label
              className="lato-medium-20 text-white mb-2 text-center w-100"
              htmlFor="confirmPassword"
            >
              Confirm Password
            </label>
            <input
              type="password"
              className="form-control bg-white bg-opacity-75 border-0 rounded-1 py-4-5 px-4 lato-medium-16 w-100"
              id="confirmPassword"
              placeholder="Confirm Password"
            />
          </div>
          <button
            type="submit"
            className="btn lato-bold-25u w-100 py-3 mt-5"
            style={{
              background: "#ff1be6",
              color: "#fff",
              border: "none",
              fontWeight: 700,
              fontSize: 20,
              textTransform: "uppercase",
              letterSpacing: 0,
            }}
          >
            CREATE
          </button>
        </form>
      </div>
    </div>
  );
};

export default HostRegister;
